var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4135",
    "data-name": "Group 4135",
    transform: "translate(-432 -887.996)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1042",
    "data-name": "Ellipse 1042",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(432 887.996)",
    fill: "#fe9634"
  }), /*#__PURE__*/React.createElement("g", {
    id: "clock-afternoon-fill",
    transform: "translate(453.832 909.561)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1681",
    "data-name": "Rectangle 1681",
    width: 28,
    height: 28,
    transform: "translate(0.168 0.436)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9707",
    "data-name": "Path 9707",
    d: "M36.363,24A12.363,12.363,0,1,0,48.725,36.363,12.363,12.363,0,0,0,36.363,24Zm6.657,13.314H38.658L41.742,40.4A.951.951,0,1,1,40.4,41.742L35.69,37.035c-.022-.022-.043-.046-.063-.07s-.016-.022-.025-.033-.021-.028-.031-.042-.017-.027-.025-.041-.016-.026-.023-.039-.014-.028-.02-.042-.014-.028-.02-.042-.01-.028-.015-.042-.011-.03-.016-.046-.007-.028-.011-.042-.008-.032-.012-.048-.005-.033-.007-.049,0-.028-.006-.043q0-.045,0-.091V36.36q0-.046,0-.091c0-.014,0-.028.006-.043s0-.033.007-.049.008-.032.012-.048.007-.028.011-.042.011-.031.016-.046.01-.028.015-.042.013-.028.019-.042.013-.029.02-.042.015-.026.023-.039.016-.027.025-.041.02-.028.031-.042.016-.022.025-.033a.956.956,0,0,1,.133-.133l.033-.025.041-.03.042-.025.038-.023.043-.021L36,35.484l.043-.016.045-.016.044-.011.046-.011.051-.008.041-.006q.047,0,.094,0h6.657a.951.951,0,1,1,0,1.9Z",
    transform: "translate(-22.195 -21.927)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInreview);
export default __webpack_public_path__ + "static/media/inreview.5da79a18fe6c98d963adf5092bbb12d8.svg";
export { ForwardRef as ReactComponent };